<div class="maincontainer">
  <div class="formContainer">
    <div [formGroup]="form" class="form">
      <label>
        <input type="email" formControlName="email" placeholder="{{ 'admin.invite.email.placeholder' | translate }}" />
      </label>
      <label>
        <input type="text" formControlName="firstName" placeholder="{{ 'admin.invite.firstname.placeholder' | translate }}" />
      </label>
      <label>
        <input type="text" formControlName="lastName" placeholder="{{ 'admin.invite.lastname.placeholder' | translate }}" />
      </label>
      <div class="nwp-select">
        <kion-select
                [options]="basestores$ | async"
                id="select-basestore"
                controlName="baseStore"
                [form]="form"
                [disablePlaceHolder]="true">
        </kion-select>
        <div *ngFor="let role of roles">
          <label [hidden]="!(hasPrivlege$(role.privilege) | async)">
            {{ role.name }}
            <input type="checkbox" placeholder="{{ role.name }}" (click)="addRoles(role.id)" value="{{ role.name }}" [checked]="selectedRoles[role.id]"/>
          </label>
        </div>
      </div>
      <button (click)="inviteUser()" [disabled]="isSending">{{ 'admin.invite.button.send' | translate }}</button>
    </div>
  </div>
</div>
